import { objectEntries } from 'core/utils';
import type { TreeGrid } from '../types';

export type CreateRowDefConfig<TColumns extends string> = Omit<TreeGrid.RowDef, 'CalcOrder'> & {
  /**
   * @deprecated use Cells instead
   */
  Columns?: TreeGrid.Col<TColumns>[];
  Cells?: TreeGrid.Cell<TColumns>[];
};

export const createRowDef = <TColumns extends string>(config: CreateRowDefConfig<TColumns>) => {
  const { Columns, Cells, CalcOrder = [], ..._config } = config;

  const rowDef: TreeGrid.RowDef = _config;

  const cells = Columns || Cells;
  const calcOrder: string[] = [];

  if (cells) {
    cells.forEach(col => {
      const colName = col.Name;
      objectEntries(col).forEach(([key, value]) => {
        if (key === 'Name') return;

        // Combine cell options except value: titleType and title.
        const prop = key === colName ? key : `${colName}${key}`;

        if (key === 'Formula') {
          calcOrder.push(colName);
        } else if (prop.endsWith('Formula')) {
          calcOrder.push(prop.replace(/Formula$/, ''));
        }

        rowDef[prop] = value;
      });
    });
  }

  if (calcOrder.length > 0 || CalcOrder.length > 0) {
    rowDef.CalcOrder = [...CalcOrder, ...calcOrder].join(',');
    rowDef.Calculated = 1;
  }

  return rowDef;
};
